export default __webpack_public_path__ + "e8ce654357406cc702952ac6c53a39f4.webp";